import React, { Component } from 'react';
import {Button, Col, ControlLabel, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import update from 'immutability-helper';
import Loading from '../components/Loading'
import {connect} from "react-redux";
import * as ClientsAction from "../actions/ClientActions";
import HoursFormControl from "./HoursFormControl";

class FirstTimeSetup extends Component {
    constructor(){
        super();
        this.state = {
            form: {
                client: "",
                project: "",
                task: "",
                budget: "",
            },
            budgetMinutes: 0,
            saving: false,
            projectSaved: false,
            taskSaved: false,
        }
    }

    handleChange(event) {
        this.setState(update(this.state, {
            form: {
                [event.target.name]: {$set: event.target.value}
            }
        }));

        if(event.target.name === "budget"){
            this.setState({budgetMinutes: event.target.minutes})
        }
    }

    save(event){
        event.preventDefault();

        this.setState({saving: true});

        const {client, project, task} = this.state.form;

        this.props.saveClientProjectTask({
            name: client
        },{
            name: project
        },{
            name: task,
            budgetMinutes: this.state.budgetMinutes
        });
    }

    render() {

        return (
            <div className="card" style={{width: "70%", margin: "0 auto"}}>
                <div className="card-heading">
                    <h1 className="card-title">
                        Initial Setup
                        <Loading right loading={this.state.saving}/>
                    </h1>
                </div>
                <div className="card-body">
                    <Form horizontal onSubmit={this.save.bind(this)}>
                        <FormGroup>
                            <Row>
                                <Col sm={9} smOffset={3}>
                                    <p>Thank you for trying out T-Rex. Before we begin, let's setup your account. First we need to create a new client. Please provide the name of your first client. (You can change this name later)</p>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col sm={3} componentClass={ControlLabel}>
                                    Client name
                                </Col>
                                <Col sm={9}>
                                    <FormControl componentClass="input" name="client" value={this.state.form.client} onChange={this.handleChange.bind(this)} />
                                </Col>
                            </Row>
                        </FormGroup>
                        {this.state.form.client  && (
                            <div>
                                <FormGroup>
                                    <Row>
                                        <Col sm={9} smOffset={3}>
                                            <p>Second, you need to define a project for the client for which you are planning to make hours. In the free tier you can only have one client and one project, but for the premium tier there are no limits.</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3} componentClass={ControlLabel}>
                                            Project name
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" name="project" value={this.state.form.project} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        )}
                        {this.state.form.project  && (
                            <div>
                                <FormGroup>
                                    <Row>
                                        <Col sm={9} smOffset={3}>
                                            <p>You can define several tasks within a project to catogorize your hours. Let's start with a single task, you can add more later.</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3} componentClass={ControlLabel}>
                                            Task
                                        </Col>
                                        <Col sm={9}>
                                            <FormControl componentClass="input" name="task" value={this.state.form.task} onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        )}
                        {this.state.form.task  && (
                            <div>
                                <FormGroup>
                                    <Row>
                                        <Col sm={9} smOffset={3}>
                                            <p>For each task you can set a budget, so you can keep track of your performance. In T-Rex you can enter time in the format hh:mm or as a decimal number, e.g. 2:30 or 2.5.</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={3} componentClass={ControlLabel}>
                                            Budget
                                        </Col>
                                        <Col sm={9}>
                                            <HoursFormControl componentClass="input" name="budget" value={this.state.form.budget} placeholder="1:00" onChange={this.handleChange.bind(this)} />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        )}
                        {this.state.form.budget  && (
                            <div>
                                <FormGroup>
                                    <Row>
                                        <Col sm={9} smOffset={3}>
                                            <p>That's it! You are ready to start using T-Rex.</p>
                                        </Col>
                                    </Row>
                                </FormGroup>
                                <FormGroup>
                                    <Row>
                                        <Col sm={9} smOffset={3}>
                                            <Button bsStyle="primary" type="submit" disabled={this.state.saving}>Save</Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </div>
                        )}
                    </Form>

                </div>
            </div>
        );
    }
}
export default connect(state => ({
    clients: state.clients,
    projects: state.projects,
    tasks: state.tasks,
}), dispatch => ({
    saveClientProjectTask: (client, project, task) => dispatch(ClientsAction.saveClientProjectTask(client, project, task)),
}))(FirstTimeSetup);


// WEBPACK FOOTER //
// ./src/components/FirstTimeSetup.js